import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import * as Styles from './Dropdown.styles';

const Dropdown = ({
  defaultOption = null,
  name,
  options,
  formik,
  onChange,
  placeholder = '',
  inputLabel = '',
  forceUpdate = false,
  isTrendStyle = false,
  ...rest
}) => {
  const [value, setValue] = useState(defaultOption);

  useEffect(() => {
    if (value === null || forceUpdate) {
      setValue(defaultOption);
    }
  }, [defaultOption]);

  useEffect(() => {
    if (formik && formik?.values?.[name]) {
      const item = options.find((o) => o.value === formik.values[name]);
      if (item) {
        setValue(item);
      }
    }
  }, [, formik?.values?.[name]]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (formik) {
      formik.handleChange({
        target: {
          name,
          value: newValue?.value || '',
        },
      });
    }
    if (onChange) {
      onChange(newValue);
    }
  };

  if (isTrendStyle) {
    return (
      <Styles.Autocomplete
        {...rest}
        value={value}
        name={name}
        onChange={handleChange}
        options={options}
        loadingText="Đang tải dữ liệu..."
        noOptionsText="Không tìm thấy kết quả."
        renderInput={(params) => <TextField {...params} label={inputLabel} />}
        renderOption={(props, option) => (
          <Box component="li" sx={{ '& > img': { flexShrink: 0 } }} {...props}>
            {option.label}
            {option?.upTrend ? (
              <img
                src="/images/icons/campfire.png"
                alt="Up Trend"
                className="w-4 h-4 min-w-4 inline-block"
              />
            ) : null}
          </Box>
        )}
      />
    );
  }

  if (inputLabel) {
    return (
      <Styles.Autocomplete
        {...rest}
        value={value}
        name={name}
        onChange={handleChange}
        options={options}
        loadingText="Đang tải dữ liệu..."
        noOptionsText="Không tìm thấy kết quả."
        renderInput={(params) => <TextField {...params} label={inputLabel} />}
      />
    );
  }

  return (
    <Styles.Autocomplete
      {...rest}
      value={value}
      name={name}
      onChange={handleChange}
      options={options}
      loadingText="Đang tải dữ liệu..."
      noOptionsText="Không tìm thấy kết quả."
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholder} />
      )}
    />
  );
};

export default Dropdown;

export function BasicSelect({
  onChange,
  defaultValue,
  options,
  id,
  name
}) {
  const [value, setValue] = useState(defaultValue || '');

  useEffect(() => {
    if (defaultValue && !value) {
      setValue(defaultValue)
    }
  }, [defaultValue])

  const handleChange = (event) => {
    setValue(event.target.value);
    if (onChange) {
      const item = options.find((i) => i.value === event.target.value)
      onChange(item)
    }
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <Styles.Select
          id={id || name}
          value={value}
          onChange={handleChange}
          name={name}
        >
          {options?.map((item) => (
            <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
          ))}
        </Styles.Select>
      </FormControl>
    </Box>
  );
}
